import React from 'react';
import { useParams } from 'react-router-dom';
import ArticleCard from '../components/ArticleCard';
import useNews from '../hooks/useNews';

const names = {
  news: 'News',
  asia: 'Asia',
  europe: 'Europe',
  sport: 'Sport',
  business: 'Business',
  technology: 'Technology',
  health: 'Health',
  culture: 'Culture',
  arts: 'Arts',
  travel: 'Travel',
  earth: 'Earth',
  trending: 'Trending'
};

function Listing() {
  const { section = 'news' } = useParams();
  const title = names[section] || 'News';
  const category = section === 'news'
    ? undefined
    : names[section];

  const { articles, loading, error } = useNews({
    category,
    limit: 100,
    orderBy: section === 'trending' ? 'view_count' : 'published_at'
  });

  return (
    <div className="shell page-space">
      <header className="page-header">
        <span className="eyebrow">OPINIGURU</span>
        <h1>{title}</h1>
        <p>
          Reporting, context and perspective on the stories shaping our
          communities and the wider world.
        </p>
      </header>

      {loading && <p className="result-count">Retrieving the latest stories…</p>}
      {error && <p className="result-count">{error} Showing available stories.</p>}

      <div className="listing-grid">
        {articles.map((article, index) => (
          <ArticleCard
            key={article.id}
            article={article}
            horizontal={index === 0}
          />
        ))}
      </div>
    </div>
  );
}

export default Listing;